import { SettingsPageLayout } from '@front/components/settings/SettingsPageLayout';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/settings')({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SettingsPageLayout>
      <Outlet />
    </SettingsPageLayout>
  );
}
